import gql from 'graphql-tag';
import STUDENT_FRAGMENT from 'graph/fragments/student';
const CREATE_STUDENTS = gql`
  mutation createStudents($students: [StudentCreateInput!]!) {
    createStudents(data: $students) {
      ...BaseStudent
    }
  }
  ${STUDENT_FRAGMENT}
`;

export default CREATE_STUDENTS;
